import { Vns } from '../types';
import { CommonApi, CommonApiMethod } from '.';
const route = 'vns';
const vns: CommonApiMethod = new CommonApi<Vns>(route, 'ВНС');

export default vns;
